module.exports = __webpack_public_path__ + "new-in-competition.png?1e08126e9342b86d99b78d5555f15f9d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-in-competition.png
// module id = 986
// module chunks = 2